import React, { useEffect, useRef, useState } from "react";
import { RouteComponentProps } from "react-router-dom";
import ImagerApi from "../../api/ImagerApi";
import { EModuleType } from "../../Model/EModuleType";
import { Module } from "../../Model/Module";
import { getModules } from "../../redux/reducers/ModuleReducer";
import { useTypedSelector } from "../../redux/reducers/RootReducer";
import LightPathUtil from "../../Utility/LightPathUtil";
import Breadcrumb from "../Header/Breadcrumb";
import Header from "../Header/Header";
import LayoutContent from "../LayoutContent";
import ImageGallery, { GalleryImgSrc } from "./ImageGallery";
import ImagerNavSubMenu from "./ImagerNavSubMenu";
import { getImagerCapabilities } from "../../redux/reducers/ImagerCapabilitiesReducer";
import { Collection } from "../../Model/Collection";
import { ImagerCapability } from "../../Model/ImagerCapabilities";

type LastImgParams = {
  imagerIdentifier: string;
  lightpath: string;
};

async function getGalleryImages(
  imagerModules: Module[],
  imagerCapabilitiesCollection: Collection<ImagerCapability>
): Promise<GalleryImgSrc[]> {
  let result: GalleryImgSrc[] = [];
  console.log("getGalleryImages", { imagerCapabilitiesCollection });
  for (let i = 0; i < imagerModules.length; i++) {
    const imager = imagerModules[i];
    const lightPaths =
      imagerCapabilitiesCollection.byId[imager.identifier].lightpathCollection
        .allIds;
    console.log(
      "getGalleryImages",
      { lightPaths },
      { imagerCapabilitiesCollection }
    );

    for (let l = 0; l < lightPaths.length; l++) {
      const lightPath = lightPaths[l];
      const imageSrc = await ImagerApi.lastCapturedImage(
        imager.identifier,
        lightPath
      )
      
      if(imageSrc !== ""){
        result.push({
          name: `${imager.name}\n${LightPathUtil.toName(lightPath)}`,
          imageSrc: imageSrc,
        });
      }
    }
  }

  return result;
}

export default function LastViewImage({
  match,
}: RouteComponentProps<LastImgParams>) {
  // const [imgSize, setImgSize] = useState([0, 0]);
  const lastImg = useRef<HTMLImageElement>(null);
  const parent = useRef<HTMLDivElement>(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [galleryImgSrc, setGalleryImgSrc] = useState([] as GalleryImgSrc[]);
  const imagerModules = useTypedSelector((state) =>
    getModules(state, EModuleType.IMAGER)
  );
  const imagerIdentifier =
    match.params.imagerIdentifier || imagerModules[0].identifier;
  const imagerCapabilitiesCollection = useTypedSelector((state) =>
    getImagerCapabilities(state)
  );

  useEffect(() => {
    getGalleryImages(imagerModules, imagerCapabilitiesCollection).then(
      (src) => {
        setGalleryImgSrc(src);
      }
    );
  }, [imagerModules, imagerCapabilitiesCollection]);

  const onImageLoaded = () => {
    if (lastImg.current != null && parent.current != null) {
      const widthRatio =
        lastImg.current.naturalWidth / parent.current.clientWidth;
      const heightRatio =
        lastImg.current.naturalHeight / parent.current.clientHeight;
      const ratio = Math.max(widthRatio, heightRatio);

      lastImg.current.width = lastImg.current.naturalWidth / ratio;
      lastImg.current.height = lastImg.current.naturalHeight / ratio;
    }
  };

  const onClickGallery = (index: number) => {
    setSelectedIndex(index);
  };

  // useEffect(() => {
  //   if (
  //     lastImg != null &&
  //     lastImg.current != null &&
  //     parent != null &&
  //     parent.current != null
  //   ) {
  //     const parentWidth = parent.current.clientWidth;
  //     const parentHeight = parent.current.clientHeight;
  //     const imgWidth = imgSize[0];
  //     const imgHeight = imgSize[1];
  //     const ratio = Math.min(parentWidth / imgWidth, parentHeight / imgHeight);
  //     const scaleWidth = imgWidth * ratio;
  //     const scaleHeight = imgHeight * ratio;

  //     lastImg.current.width = scaleWidth;
  //     lastImg.current.height = scaleHeight;
  //     lastImg.current.style.left = (parentWidth - scaleWidth) / 2 + "px";
  //   }
  // }, [imgSize]);

  return (
    <LayoutContent>
      <LayoutContent.Header>
        <Header>
          <Breadcrumb
            items={[
              {
                title: "Last Captured Images",
                to: "/imager/last-captured/" + imagerIdentifier,
                disabled: false,
              },
            ]}
          />
        </Header>
      </LayoutContent.Header>
      <LayoutContent.SubMenu>
        <ImagerNavSubMenu imagerIdentifier={imagerIdentifier} />
      </LayoutContent.SubMenu>
      <LayoutContent.Content>


      <div
          ref={parent}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
          }}
        >
          <img
            ref={lastImg}
            src={
              galleryImgSrc.length > selectedIndex
                ? galleryImgSrc[selectedIndex].imageSrc
                : undefined
            }
            onLoad={onImageLoaded}
            alt=""
          />
        </div>

{/* 
        <div
          ref={parent}
          style={{
            height: "100%",
            width: "100%",
            position: "relative",
            backgroundColor: "gray",
          }}
        >
          <img
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              position: "absolute",
              left: 0,
              top: 0,
            }}
            ref={lastImg}
            src={
              galleryImgSrc.length > selectedIndex
                ? galleryImgSrc[selectedIndex].imageSrc
                : undefined
            }
            onLoad={onImageLoaded}
            alt=""
          />
        </div> */}
      </LayoutContent.Content>
      <LayoutContent.CommandPanel>
        <ImageGallery
          title={"Last Captured Image"}
          items={galleryImgSrc}
          onClickItem={onClickGallery}
          selectedIndex={selectedIndex}
        />
      </LayoutContent.CommandPanel>
    </LayoutContent>
  );
}
